import React from 'react';
import { useLocation } from 'react-router-dom';

import { ReservationStatus, ShippingStatus } from '../../graphql/API';
import useReservationQuery from '../../hooks/reactQuery/useReservationQuery';
import useVenueId from '../../hooks/useVenueId';
import { ShipmentReminderDialog } from '../Dialogs/ShipmentReminder/ShipmentReminderDialog';

export const ShipmentReminder = () => {
  const location = useLocation();
  const venueID = useVenueId();
  const lastLoggedInVenueIDStorage = localStorage.getItem('lastLoggedInVenueID-popup');
  const lastLoggedInVenueID = lastLoggedInVenueIDStorage
    ? JSON.parse(lastLoggedInVenueIDStorage)
    : '';

  const [isPopupOpen, setIsPopupOpen] = React.useState(false);
  const storageKey = 'reservations_reminder_popup_last_seen';

  const {
    data: reservations,
    isFetching,
    isLoading,
  } = useReservationQuery(
    {
      sortBy: 'createdAt',
      sortDirection: 'desc',
      shippingStatus: ShippingStatus.waiting,
      status: [ReservationStatus.reserved],
    },
    venueID,
    9999,
  );

  React.useEffect(() => {
    if (String(lastLoggedInVenueID) !== String(venueID)) {
      localStorage.setItem(storageKey, JSON.stringify(''));
      localStorage.setItem('lastLoggedInVenueID-popup', JSON.stringify(venueID));
    }
  }, [lastLoggedInVenueID, venueID]);

  React.useEffect(() => {
    const checkPopupEligibility = async () => {
      if (location.pathname === '/chats') return;

      const lastSeen = localStorage.getItem(storageKey);
      if (lastSeen && Date.now() - parseInt(lastSeen, 10) < 24 * 60 * 60 * 1000) {
        return;
      }

      const pendingReservations = reservations.filter(
        (res) => res.shippingStatus === ShippingStatus.waiting,
      );

      if (pendingReservations.length >= 1) {
        setIsPopupOpen(true);
      }
    };

    if (!isLoading && !isFetching) checkPopupEligibility();
  }, [isFetching, isLoading, lastLoggedInVenueID, location.pathname, reservations, venueID]);

  const handleClose = () => {
    setIsPopupOpen(false);
    localStorage.setItem(storageKey, Date.now().toString());
  };

  return (
    <ShipmentReminderDialog
      open={isPopupOpen}
      onClose={() => {
        handleClose();
      }}
      reservations={reservations}
    />
  );
};
